import {isNotNil} from 'ramda';

import {Video} from '../types/video';

export const isVideoPlayable = (videoAsset: Video) =>
  // Has original file with a URL
  isNotNil(videoAsset.originUrl) ||
  // Or has at least one variant with a URL
  (videoAsset.variants?.filter((variant) => isNotNil(variant.url)).length ?? 0) > 0;
